import { connect } from 'react-redux';
import { loadGameReportReferee, loadScores } from '../../store/actions/games';
import { changePage, isLoading } from '../../store/actions/app';
import { confirmGameReportReferee, overwriteGameReportReferee, saveGameReportRefereeDraft, signGameReportReferee } from '../../store/actions/gameReportReferee';
import { loadReferees } from '../../store/actions/referees';
import { updateGameReportReferee, dismissGameReportRefereeChanges } from '../../store/actions/localChanges';
import * as defaults from '../../store/defaults/gameReportReferee';
import GameReportReferee from '../../components/Pages/GameReportReferee';

const mapStateToProps = state => {

    // console.log( 'containers.Pages.GameReportReferee.mapStateToProps', state );

    const activeGame                  = state.items.games.activeItem;
    const gameInfo                    = {};
      let gameReportReferee           = null;
      let gameReportRefereeLastUpdate = null;
      let gameReportRefereeMeta       = null;
      let localChanges                = null;
      let referees                    = null;
      let refereesLastUpdate          = null;

    if ( activeGame ) {

        if ( state.items.gameReportsReferee && ( activeGame.id in state.items.gameReportsReferee ) ) {

            gameReportReferee           = state.items.gameReportsReferee[ activeGame.id ].gameReportReferee;
            gameReportRefereeLastUpdate = new Date( state.items.gameReportsReferee[ activeGame.id ].lastUpdate );
            gameReportRefereeMeta       = state.items.gameReportsReferee[ activeGame.id ].meta;

        }

        if ( state.localChanges.gameReportsReferee && ( activeGame.id in state.localChanges.gameReportsReferee ) ) {

            localChanges = state.localChanges.gameReportsReferee[ activeGame.id ];

        }

        if ( activeGame.permission === 'referee' ) {

            if ( state.items.referees && ( activeGame.id in state.items.referees ) ) {

                referees           = state.items.referees[ activeGame.id ].items;
                refereesLastUpdate = new Date( state.items.referees[ activeGame.id ].lastUpdate );

            }

            gameInfo.gameDate                  = ! activeGame.dateIsToBeDetermined && activeGame.scheduledDate ? activeGame.scheduledDate.value : null;
            gameInfo.gameName                  = activeGame.gameName;
            gameInfo.gameStart                 = ! activeGame.timeIsToBeDetermined ? activeGame.scheduledTime : null;

            gameInfo.teamInfoAway              = {}
            gameInfo.teamInfoAway.colorHelmets = activeGame.awayTeam.defaultColors.helmets;
            gameInfo.teamInfoAway.colorPants   = activeGame.awayTeam.defaultColors.pants;
            gameInfo.teamInfoAway.colorShirts  = activeGame.awayTeam.defaultColors.shirts;
            gameInfo.teamInfoAway.colorSocks   = activeGame.awayTeam.defaultColors.socks;
            gameInfo.teamInfoAway.teamName     = activeGame.awayTeam.longName;

            gameInfo.teamInfoHome              = {}
            gameInfo.teamInfoHome.colorHelmets = activeGame.homeTeam.defaultColors.helmets;
            gameInfo.teamInfoHome.colorPants   = activeGame.homeTeam.defaultColors.pants;
            gameInfo.teamInfoHome.colorShirts  = activeGame.homeTeam.defaultColors.shirts;
            gameInfo.teamInfoHome.colorSocks   = activeGame.homeTeam.defaultColors.socks;
            gameInfo.teamInfoHome.teamName     = activeGame.homeTeam.longName;

        }

    }

    return {

        context:               state.auth.context,
        gameReportReferee:     { ...defaults.gameReportReferee, ...gameInfo, ...gameReportReferee, ...localChanges },
        gameReportRefereeMeta: { ...defaults.gameReportRefereeMeta, ...gameReportRefereeMeta },
        hasLocalChanges:       localChanges !== null,
        loading:               state.app.loading,
        token:                 state.auth.token,
        username:              state.auth.username,
        userSettings:          state.userSettings,

        activeGame, gameReportRefereeLastUpdate, referees, refereesLastUpdate

    };

};

const mapDispatchToProps = dispatch => {

    return {
        onChangePage:                route                                                   => dispatch( changePage( route ) ),
        onConfirm:                 ( context, token, gameId, gameReportReferee, username   ) => dispatch( isLoading( true ) ) && dispatch( confirmGameReportReferee( context, token, gameId, gameReportReferee, username ) ),
        onDismissChanges:            gameId                                                  => dispatch( dismissGameReportRefereeChanges( gameId ) ),
        onLoadGameReportReferee:   ( context, token, gameId                                ) => dispatch( isLoading( true ) ) && dispatch( loadGameReportReferee( context, token, gameId ) ),
        onLoadReferees:            ( context, token, gameId                                ) => dispatch( isLoading( true ) ) && dispatch( loadReferees( context, token, gameId ) ),
        onLoadScores:              ( context, gameId                                       ) => dispatch( isLoading( true ) ) && dispatch( loadScores( context, gameId ) ),
        onOverwrite:               ( context, token, gameId, gameReportReferee             ) => dispatch( isLoading( true ) ) && dispatch( overwriteGameReportReferee( context, token, gameId, gameReportReferee ) ),
        onSaveDraft:               ( context, token, gameId, gameReportReferee             ) => dispatch( isLoading( true ) ) && dispatch( saveGameReportRefereeDraft( context, token, gameId, gameReportReferee ) ),
        onSign:                    ( context, token, gameId, team, comment, name, username ) => dispatch( isLoading( true ) ) && dispatch( signGameReportReferee( context, token, gameId, team, comment, name, username ) ),
        onUpdateGameReportReferee: ( gameId,  data                                         ) => dispatch( updateGameReportReferee( gameId, data ) )
    };

};

export default connect( mapStateToProps, mapDispatchToProps )( GameReportReferee );